import produce from "immer";
import * as types from "../types";

const initialState = {
  traslados: [],
  estado: [],
  trasladosExportar: [],
  traslado: {},
  isLoading: false,
  error: null,
  page: 1,
  pageSize: 25,
  pageMax: false,
  dataBuscar: {},
  showModal: false,
  editMode: false,
  preTraslado: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.GET_TRASLADOS:
    case types.GET_TRASLADOS_EXPORTAR:
    case types.GET_TRASLADO:
    case types.CREATE_TRASLADO:
    case types.UPDATE_TRASLADO:
    case types.DELETE_TRASLADO:
    case types.GET_TRASLADOS_ESTADO:
    case types.TOOGLE_TRASLADO_ESTATUS:
    case types.TOGGLE_TRASLADO_REPARACION:
      return produce(state, (draft) => {
        draft.isLoading = true;
      });
    case types.GET_TRASLADOS_SUCCESS:
      return produce(state, (draft) => {
        draft.isLoading = false;
        draft.traslados = action.payload.traslados;
        draft.pageMax = action.payload.next === null;
        draft.error = null;
        draft.dataBuscar = action.payload.dataBuscar
          ? action.payload.dataBuscar
          : {};
        if (action.payload.buscando) draft.page = 1;
      });
    case types.GET_TRASLADOS_ESTADO_SUCCESS:
      return produce(state, (draft) => {
        draft.isLoading = false;
        draft.estado = action.payload;
        draft.error = null;
      });
    case types.TRASLADOS_NEXT_PAGE:
      return produce(state, (draft) => {
        draft.page = draft.page + 1;
      });
    case types.TRASLADOS_PREV_PAGE:
      return produce(state, (draft) => {
        draft.page = draft.page - 1;
      });
    case types.TRASLADOS_CHANGE_PAGE_SIZE:
      return produce(state, (draft) => {
        draft.page = 1;
        draft.pageSize = action.payload;
      });
    case types.TRASLADOS_SHOW_MODAL:
      return produce(state, (draft) => {
        draft.showModal = true;
      });
    case types.TRASLADOS_HIDE_MODAL:
      return produce(state, (draft) => {
        draft.showModal = false;
        draft.editMode = false;
        draft.traslado = {};
        draft.preTraslado = null;
        draft.error = null;
      });
    case types.CREATE_TRASLADO_SUCCESS:
      return produce(state, (draft) => {
        draft.isLoading = false;
        draft.error = null;
        draft.showModal = false;
        draft.preTraslado = null;
      });
    case types.GET_TRASLADO_SUCCESS:
      return produce(state, (draft) => {
        draft.isLoading = false;
        draft.error = null;
        draft.editMode = true;
        draft.showModal = true;
        draft.traslado = action.payload;
      });
    case types.UPDATE_TRASLADO_SUCCESS:
    case types.DELETE_TRASLADO_SUCCESS:
    case types.TOOGLE_TRASLADO_ESTATUS_SUCCESS:
    case types.TOGGLE_TRASLADO_REPARACION_SUCCESS:
      return produce(state, (draft) => {
        draft.isLoading = false;
        draft.error = null;
        draft.editMode = false;
        draft.traslado = {};
        draft.showModal = false;
      });
    case types.TRASLADOS_ERROR:
      return produce(state, (draft) => {
        draft.isLoading = false;
        draft.error = action.payload ? action.payload : "offline";
      });
    case types.TRASLADOS_SET_EXPORTANDO:
      return produce(state, (draft) => {
        draft.exportando = action.payload;
      });
    case types.TRASLADOS_SET_PRETRASLADO:
      return produce(state, (draft) => {
        draft.preTraslado = action.payload;
      });
    case types.GET_TRASLADOS_EXPORTAR_SUCCESS:
      return produce(state, (draft) => {
        draft.isLoading = false;
        // draft.showModal = false;
        draft.trasladosExportar = action.payload.trasladosExportar;
        draft.error = null;
        draft.exportando = true;
      });
    default:
      return state;
  }
};
